import { render } from "./Index.vue?vue&type=template&id=2a071e1a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2a071e1a"

export default script